import SArtLovers from "./SArtLovers_web"
export default SArtLovers
